import React, {useState, useEffect, useRef} from 'react';
import {useTranslation} from 'react-i18next';
import {Link} from 'react-router-dom';
import {FaIcon} from '../FaIcon';
import {Switch} from '../buttons/Swtich';
import {AccessService} from '../../utils/AccessService';
import {LocalStorage} from '../../utils/LocalStorage';

// Las únicas 3 funcionalidades reales que la agencia puede asignar al usuario tipo Client.
// Compartido entre:
// - EditClientFeaturesModal (/agency-team y /client/:id "editar funcionalidades")
// - InviteUserModal renderClientFeatureToggles (/agency-team invitar Client)
// - ClientPortalTab InviteClientUserModal (/client/:id invitar usuario al portal)
export const CLIENT_FEATURE_KEYS = ['connections', 'connect', 'reports', 'dashboard'];

const FEATURE_ICONS = {
    connections: 'plug',
    connect: 'microchip',
    reports: 'wand-magic-sparkles',
    dashboard: 'chart-line',
};

export const ClientFeatureToggles = ({features, onChange, readOnly = false}) => {
    const {t} = useTranslation();
    // null = cargando; true/false = si la agencia tiene el módulo Connect (DASHBO_MCP) en su plan.
    // El feature "connect" del cliente solo tiene efecto si la agencia tiene el plan: el portal del
    // cliente gatea la pestaña Connect por DASHBO_MCP (ver AccessService.get_user_modules en backend).
    // Si la agencia no lo tiene, mostramos el feature bloqueado con CTA de upgrade, coherente con
    // el patrón de DashboMCPPage / DataExplorerPage.
    const [agencyHasConnect, setAgencyHasConnect] = useState(null);
    const forcedConnectOff = useRef(false);

    useEffect(() => {
        const userId = LocalStorage.fetchUserId();
        if (!userId) {
            setAgencyHasConnect(false);
            return;
        }
        AccessService.GetUserModules(userId, (data) => {
            const modules = data.modules || [];
            setAgencyHasConnect(modules.includes(AccessService.MODULE_DASHBO_MCP));
        }, () => {
            setAgencyHasConnect(false);
        });
    }, []);

    // Sin plan Connect el feature no debe quedar en true por el default: lo apagamos una vez.
    useEffect(() => {
        if (agencyHasConnect === false && features.connect && !forcedConnectOff.current) {
            forcedConnectOff.current = true;
            onChange('connect', false);
        }
    }, [agencyHasConnect, features.connect, onChange]);

    const connectLocked = agencyHasConnect === false;

    return (
        <div className="invite-client-features">
            {CLIENT_FEATURE_KEYS.map(key => {
                const isConnectLocked = key === 'connect' && connectLocked;
                return (
                    <div key={key} className="invite-feature-row">
                        <div className="invite-feature-info">
                            <FaIcon iconName={FEATURE_ICONS[key]} className="invite-feature-icon"/>
                            <div className="invite-feature-text">
                                <span className="invite-feature-name">{t(`invite_user.feature_${key}`)}</span>
                                <span className="invite-feature-desc">
                                    {isConnectLocked
                                        ? t('invite_user.feature_connect_locked')
                                        : t(`invite_user.feature_${key}_desc`)}
                                </span>
                            </div>
                        </div>
                        {isConnectLocked ? (
                            <Link
                                to="/dashbo-mcp"
                                target="_blank"
                                className="invite-feature-upgrade-cta"
                            >
                                <FaIcon iconName="lock"/>
                                <span>{t('invite_user.feature_connect_upgrade_cta')}</span>
                            </Link>
                        ) : readOnly ? (
                            <span className={`invite-feature-readonly ${features[key] ? '-on' : '-off'}`}>
                                {features[key] ? t('portal_modules.toggle_on') : t('portal_modules.toggle_off')}
                            </span>
                        ) : (
                            <Switch
                                name={`feature_${key}`}
                                checked={!!features[key]}
                                onChange={(e) => onChange(key, e.target.checked)}
                                style={{margin: 0}}
                            />
                        )}
                    </div>
                );
            })}
        </div>
    );
};
